import React, { useEffect, useState } from "react";
import firebase from "./firebase";

export const AuthContext = React.createContext({});
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loadingAuthState, setLoadingAuthState] = useState(true);
  const [language, setLanguage] = useState("hu");
  const [sounds, setSounds] = useState(true);
  const [activeGame, setActiveGame] = useState(false);
  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      setUser(user);
      setLoadingAuthState(false);
    });
  }, []);
  return (
    <AuthContext.Provider
      value={{
        user,
        authenticated: user !== null,
        setUser,
        loadingAuthState,
        language,
        setLanguage,
        sounds,
        setSounds,
        activeGame,
        setActiveGame,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
